import './ThankYouAlternative.css';
import parse from 'html-react-parser';
import { useScrollToTop } from '../../lib/hooks';
import Disclaimer from '../Disclaimer/Disclaimer';
import { useLendersContext } from '../../lib/contexts';

function ThankYouThumbtack() {
  useScrollToTop();
  const zipCode = localStorage.getItem('zipCode');
  const utmSource = 'cma-rgrmarketing';
  const category = '166570397309092258';
  const { pixel } = useLendersContext();
  const parsedPixel = parse(pixel || '');
  const baseUrl =
    process.env.REACT_APP_ENV === 'staging'
      ? process.env.REACT_APP_STAGING_THUMBTACK
      : process.env.REACT_APP_THUMBTACK;
  return (
    <div className="thank-you-thumbtack__container">
      {pixel && (
        <div className="thank-you-alternative-lenders__pixel">
          {parsedPixel}
        </div>
      )}
      <div className="thank-you-alternative__box thank-you-alternative__main-box">
        <iframe
          src={`${baseUrl}/embed/pro-list?category_pk=${category}&utm_source=${utmSource}&zip_code=${zipCode}&utm_campaign=gwt&utm_medium=partnership&iframe_id=1`}
          id="1"
          sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          className="iframe-thumbtack"
        />
      </div>
      <div className="disclaimer" style={{ width: '100%' }}>
        <Disclaimer />
      </div>
    </div>
  );
}

export default ThankYouThumbtack;
